<button [class]="class" [id]="id" [type]="type"
        [style]="style"
        [class.disabled]="disabled || (spinnerStatus && spinner && buttonId == id)"
        [disabled]="disabled || (spinnerStatus && buttonId == id)"
        (click)="onClick(id!)">
    <div [ngClass]="{ 'position-relative spinning' : spinner && spinnerStatus && buttonId && buttonId == id }">
        <ng-content></ng-content>
    </div>
</button>
